// src/modules/restaurant/pages/orders/components/order-details/ProductList.tsx
import React from "react";
import { ChevronDown, ChevronUp, ShoppingBasket } from "lucide-react";
import { Order } from "src/shared/services/interfacev2";

interface Props {
  selectedOrder: Order;
  getBgClass: () => string;
  getLightBgClass: () => string;
  showProducts: boolean;
  setShowProducts: (val: boolean) => void;
}

const ProductList: React.FC<Props> = ({ selectedOrder, getBgClass, getLightBgClass, showProducts, setShowProducts }) => (
  <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm mb-2">
    <div className={`${getBgClass()} px-4 py-1 flex items-center justify-between cursor-pointer select-none`} onClick={() => setShowProducts(!showProducts)}>
      <h3 className="text-lg font-semibold text-white flex items-center gap-2 leading-none mt-1 p-1 py-0">
        <ShoppingBasket size={16} strokeWidth={2.5} /> Products ({selectedOrder.orderDetails[0].products.length})
      </h3>
      {showProducts ? (
        <ChevronUp className="w-6 h-6 text-white transition-transform duration-300 ease-in-out" />
      ) : (
        <ChevronDown className="w-6 h-6 text-white transition-transform duration-300 ease-in-out" />
      )}
    </div>

    <div className={`thin-scrollbar transition-all duration-300 ease-in-out ${showProducts ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"} overflow-auto`}>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-gray-50 border-b border-gray-200">
              <th className="text-left py-2 px-3 font-semibold text-gray-700 text-sm">Product Name</th>
              <th className="text-center py-2 px-3 font-semibold text-gray-700 text-sm">Qty</th>
              <th className="text-right py-2 px-3 font-semibold text-gray-700 text-sm">Price</th>
              {/* <th className="text-right py-2 px-3 font-semibold text-gray-700 text-sm">Total</th> */}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {selectedOrder.orderDetails[0].products.map((product, index) => (
              <tr key={index} className="hover:bg-gray-50 transition-colors duration-150">
                <td className="py-2 px-3 font-medium text-sm">{product.name}</td>
                <td className="py-2 px-3 text-center">
                  <span className={`inline-flex items-center justify-center ${getLightBgClass()} text-gray-800 px-2 py-1 rounded-full text-xs font-semibold`}>{product.quantity}</span>
                </td>
                <td className="py-2 px-3 text-right font-semibold text-sm">{(product.unitPrice.toFixed(2))}</td>
                {/* <td className="py-2 px-3 text-right font-semibold text-sm">{(product.quantity * product.unitPrice).toFixed(2)}</td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default ProductList;
